module.exports = __webpack_public_path__ + "static/img/tiantian.9c721b72.png";